import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { IciFlags } from '../../../generated/signalR/ici-flags';
import { faArrowLeft, faArrowRight, faParking, faTimes } from '@fortawesome/pro-duotone-svg-icons';
import { faRandom } from '@fortawesome/pro-solid-svg-icons';

@Enum<IciVisualizeType>('value')
export class IciVisualizeType extends EnumType<IciVisualizeType>() {
   static readonly PARK_PRIVATE = new IciVisualizeType('PARK_PRIVATE', IciFlags.PARK_PRIVATE, faParking, 'ici-park-private', 'shrink-5 right-7 down-5');
   static readonly PARK_PUBLIC = new IciVisualizeType('PARK_PUBLIC', IciFlags.PARK_PUBLIC, faParking, 'ici-park-public', 'shrink-5 right-7 down-5');
   static readonly REJECTED = new IciVisualizeType('REJECTED', IciFlags.REJECTED, faRandom, 'status-declined', 'shrink-5 left-6 up-5');
   static readonly NO_ANSWER = new IciVisualizeType('NO_ANSWER', IciFlags.NO_ANSWER, faRandom, 'status-no-answer', 'shrink-5 left-6 up-5');
   static readonly BUSY = new IciVisualizeType('BUSY', IciFlags.BUSY, faRandom, 'status-missed', 'shrink-5 left-6 up-5');

   private constructor(
      public value: string,
      public iciFlag: IciFlags,
      public icon: IconDefinition = null,
      public styleClass: string = null,
      public iconTransformCommand: string = null
   ) {
      super();
   }

   public static getAllIciVisualizationTypesForIci(ici: IciFlags): IciVisualizeType[] {
      return this.values().filter((x) => x.iciFlag & ici);
   }
}
